import styled from 'styled-components';
import { Button, IconButton } from 'ui/button';
import { spacing, caption, colors, borderRadius, heading3, Body2, fontSizes } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

export const TabTriggerText = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const CountBadge = styled.span`
  ${caption}
  color: ${colors.white};
  background: ${colors.backgroundEmphasis};
  padding: ${spacing.single} ${spacing.quarter};
  border-radius: ${borderRadius.full};
  min-width: ${spacing.plusQuarter};
  text-align: center;
`;

export const CountBadgeActive = styled(CountBadge)`
  background: ${colors.white};
  color: ${colors.backgroundInteractiveStrong};
`;

export const StyledHeading = styled.h3`
  ${heading3}
  margin: 0;
  padding: 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: ${spacing.plusHalf};

  @media screen and (max-width: ${pxToRem(893)}) {
    grid-template-columns: 1fr;
  }
`;

export const LeftGridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

export const RightGridItem = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: ${spacing.plusHalf};

  @media screen and (max-width: ${pxToRem(893)}) {
    align-items: flex-start;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: ${spacing.base};
  margin-bottom: ${spacing.plusHalf};
`;

export const EmptyGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${spacing.double} 0;
  margin-bottom: ${spacing.plusHalf};
`;

export const StyledImg = styled.img`
  display: flex;
  object-fit: contain;
  width: 100%;
  height: 250px;
  cursor: pointer;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing.double} ${spacing.plusQuarter};
  background: ${colors.grey5};
  border-radius: ${borderRadius.lg};
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled(Body2)`
  color: ${colors.textSecondary};
  & a {
    display: flex;
    align-items: center;
    color: ${colors.textSecondary};
    text-decoration: none;
    gap: ${spacing.quarter};
  } 
`;

export const ScrollContainer = styled.div`
  margin: ${spacing.double} 0;
  width: 95vw;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ isDragging }: { isDragging: boolean }) => (isDragging ? 'grabbing' : 'grab')};
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ZoomedImage = styled.img`
  object-fit: contain;
  width: calc(100% / ${({ zoom }: { zoom: number }) => zoom});
  height: 80vh;
  transform-origin: top;
  transform: scale(${({ zoom }: { zoom: number }) => zoom});
  transition: transform 0.1s ease-out;
  display: block;
  user-select: none;
  pointer-events: none;
`;

export const Controls = styled.div`
  position: absolute;
  left: ${spacing.double};
  bottom: ${spacing.double};
  display: flex;
  align-items: center;
  gap: ${spacing.base};
  width: 200px;

  & > div {
    width: 100%;
    & span {
      color: ${colors.white};
    }
  }
`;

export const CloseButton = styled(Button)`
  position: absolute;
  top: ${spacing.plusHalf};
  right: ${spacing.plusHalf};
`;

export const ZoomButton = styled(IconButton)`
  color: ${colors.white};
  font-size: ${fontSizes.s24};
`;

export const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom, black, transparent), linear-gradient(to top, black, transparent);
  background-repeat: no-repeat;
  background-size: 100% 50%, 100% 50%;
  background-position: top, bottom;
  display: flex;
  align-items: center;
  justify-content: center;
`;
